import styled from "@emotion/styled";

import { MOBILE_MAX_WIDTH, media } from "../constants";
import { Div } from "./layout";

export const Button = styled.button`
  width: ${(props) => props.width || "360px"};
  max-width: 100%;
  height: ${(props) => props.height || "45px"};
  background-color: ${({ greenButton, pinkButton, theme }) =>
    greenButton
      ? theme.palette.primary.main
      : pinkButton
      ? theme.palette.secondary.main
      : "transparent"};
  border: ${({ outlineButton, outlineButtonGreen, theme }) =>
    outlineButton
      ? `1px solid ${theme.custom.gray}`
      : outlineButtonGreen
      ? `1px solid ${theme.palette.primary.main}`
      : "1px solid transparent"};
  color: ${({ outlineButton, theme, outlineButtonGreen, temporaryButton, grayButton, deleteButton, textButton }) =>
    outlineButton
      ? theme.custom.grayDark
      : outlineButtonGreen
      ? theme.palette.primary.main
      : temporaryButton
      ? "black"
      : textButton
      ? theme.palette.text.primary
      : grayButton
      ? theme.custom.grayInputs
      : deleteButton
      ? theme.custom.red
      : theme.custom.white};
  font-size: ${(props) => (props.outlineButton ? "14px" : props.fontSize || "16px")};
  font-weight: ${(props) => props.fontWeight || (props.outlineButton ? "400" : "600")};
  text-transform: ${(props) => props.textTransform || (props.outlineButton ? "" : "uppercase")};
  padding: ${(props) => props.padding || "10px 28px"};
  border-radius: ${(props) => props.borderRadius || "30px"};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${(props) => props.zIndex || ""};
  gap: ${(props) => props.gap || "10px"};
  text-decoration: ${(props) => props.decoration || ""};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  cursor: pointer;

  ${media.max(MOBILE_MAX_WIDTH)} {
    width: ${(props) => props.width || "100%"};
    padding: 10px 15px;
  }

  &:hover {
    text-decoration: ${(props) => props.hoverDecoration || ""};
  }
`;

export const ContrastButton = styled(Button)`
  background-color: var(--main-pink);
  color: white;
  border-radius: 30px;
  width: 300px;
`;

export const ClosePopupButton = styled.img`
  label: close-popup-button;
  position: absolute;
  width: 18px;
  height: 18px;
  top: 24px;
  right: 24px;
  cursor: pointer;
`;

export const ButtonWrapper = styled(Div)`
  label: button-wrapper;
  gap: 10px;
  width: 360px;

  ${media.max(MOBILE_MAX_WIDTH)} {
    width: 100%;
    padding: 0 20px;
  }
`;

export const SocialButtons = styled(Button)`
  text-transform: none;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.custom.grayDark};
  font-family: ${({ theme }) => theme.custom.secondaryFontFamily};
`;

export const GenderButton = styled(Button)`
  width: ${(props) => props.width || "140px"};
  height: ${(props) => props.height || "140px"};
  background-color: ${({ theme, outline, selected }) =>
    outline
      ? theme.custom.white
      : selected
      ? theme.custom.greenLight
      : theme.custom.white};
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: ${(props) => props.fontWeight || "600"};
  font-size: ${(props) => (props.type ? "14px" : "16px")};
  text-transform: none;
  display: flex;
  flex-direction: column;
  border: 1px solid
    ${({ theme, outline, selected }) =>
      outline
        ? theme.custom.grayInputs
        : selected
        ? theme.palette.primary.main
        : theme.custom.grayInputs};

  @media (max-width: 480px) {
    width: ${(props) => props.width || "140px"};
    height: ${(props) => props.height || "140px"};
  }
`;

export const TabButton = styled(Button)`
  label: tab-button;
  text-transform: none;
  font-weight: ${({ active }) => (active ? 600 : 400)};
  padding: 8px 14px;
  border-radius: 24px;
  color: ${({ active, theme }) =>
    active ? theme.palette.primary.main : theme.palette.text.primary};
  border: ${({ active, theme }) =>
    active
      ? `2px solid ${theme.palette.primary.main}`
      : `1px solid ${theme.custom.grayInputs}`};
  background-color: ${({ theme }) => theme.custom.white};
  box-shadow: ${({ active }) => (active ? `0 1px 4px rgba(0,0,0,0.06)` : "none")};
`;

export const DeletePet = styled(Button)``;


